module.exports = __webpack_public_path__ + "static/media/item_10_1_comp.d6e49d35.png";